<template>
	<div class="element-box relative">
		<loading :active.sync="isLoading"></loading>
		<h6 class="element-header capitalize">
			{{ t.user.actions }}
		</h6>
		<div class="timed-activities compact">
			<div class="timed-activity" v-for="(ac, ack) in activity">
				<div class="ta-date">
					<span>{{ ack | moment('D MMMM dddd, Y', session.timezone) }}</span>
				</div>
				<div class="ta-record-w">
					<div class="ta-record" v-for=" a in ac ">
						<div class="ta-timestamp">
							<strong>{{ a.createdAt | moment('HH:MM', session.timezone) }}</strong> {{ a.createdAt | timeAgo }}
						</div>
						<div class="ta-activity" v-html="a.description">
						</div>
					</div>
				</div>
			</div>
			<div v-if="pagination">
				<router-link :to="{name: 'User' }" class="centered-load-more-link" href="#" v-if="pagination.pageCount > 1"><span>{{ t.show_all }}</span></router-link>
			</div>
		</div>
	</div>
</template>

<script>
    export default {
        name: 'activityWidget',
        data () {
            return {
                t: this.$root.t,
                session: this.$root.session,
                activity: null,
	            isLoading: false,
                pagination: null
            }
        },
	    mounted () {
            this.fetchActivity();

            //setTimeout(this.initChart(), 1000);
	    },
	    methods: {
            fetchActivity ()
            {
                this.isLoading = true;
                this.$http.get(api+'api/v1/activity?uid='+this.$route.params.id,
                    { params: this.$route.query })
                    .then(response => {
                        this.activity = response.body.result.activity;
                        this.status = response.status;
                        this.pagination = response.body.pagination;
                        this.isLoading = false;
                    }, response => {
                        this.isLoading = false;
                        this.status = response.status;
                    })
            },
		    initChart ()
		    {


		        var liteLineChart = this.$refs.canvas.getContext('2d');
                var liteLineGradientV3 = this.$refs.canvas.getContext('2d').createLinearGradient(0, 0, 0, 70);
                liteLineGradientV3.addColorStop(0, 'rgba(40,97,245,0.2)');
                liteLineGradientV3.addColorStop(1, 'rgba(40,97,245,0)');

                // line chart data
                var liteLineDataV3 = {
                    labels: ["", "FEB", "", "MAR", "", "APR", "", "MAY", "", "JUN", "", "JUL", ""],
                    datasets: [{
                        label: "Balance",
                        fill: true,
                        lineTension: 0.15,
                        backgroundColor: liteLineGradientV3,
                        borderColor: "#2861f5",
                        borderCapStyle: 'butt',
                        borderDash: [],
                        borderDashOffset: 0.0,
                        borderJoinStyle: 'miter',
                        pointBorderColor: "#2861f5",
                        pointBackgroundColor: "#fff",
                        pointBorderWidth: 2,
                        pointHoverRadius: 3,
                        pointHoverBackgroundColor: "#FC2055",
                        pointHoverBorderColor: "#fff",
                        pointHoverBorderWidth: 0,
                        pointRadius: 0,
                        pointHitRadius: 10,
                        data: [14,23,64,12,52,32,12,42,12,12,52,43],
                        spanGaps: false
                    }]
                };

                // line chart init
                var myLiteLineChartV3 = new Chart(liteLineChart, {
                    type: 'line',
                    data: liteLineDataV3,
                    options: {
                        legend: {
                            display: false
                        },
                        scales: {
                            xAxes: [{
                                ticks: {
                                    fontSize: '10',
                                    fontColor: '#969da5'
                                },
                                gridLines: {
                                    color: 'rgba(0,0,0,0.0)',
                                    zeroLineColor: 'rgba(0,0,0,0.0)'
                                }
                            }],
                            yAxes: [{
                                display: false,
                                ticks: {
                                    beginAtZero: true,
                                    max: 55
                                }
                            }]
                        }
                    }
                });


		    }
	    }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/user/widget/activityWidget.vue